<template>
  <div class="card shadow mb-4">
    <div v-if="fastTesourariaPlataforma.loading" class="col-12 text-center">
      Carregando...
    </div>
    <div v-else>
      <div>
        <div class="row d-flex steps-header justify-content-center py-2 align-items-center">
          <div class="row align-items-center">
            <span v-if="fastTesourariaPlataforma.steps === 1" class="steps-guide-active text-center my-1">
              <span class="text-nowrap">Passo 1 de 3:</span><br />
              Cálculo / Negociação
            </span>
            <span v-if="fastTesourariaPlataforma.steps === 2" class="steps-guide-active text-center my-1">
              <span class="text-nowrap">Passo 2 de 3:</span><br />
              Revisão
            </span>
            <span v-if="fastTesourariaPlataforma.steps === 3" class="steps-guide-active text-center my-1">
              <span class="text-nowrap">Passo 3 de 3:</span><br />
              Gerar cobrança
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 my-2"
          v-if="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original">
          <label class="col-sm-12 col-md-4 col-lg-4">
            Aluno
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
              .Nome_aluno
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            CPF aluno
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
              .Cpf_aluno
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Nome responsável financeiro
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
              .Nome_responsavel
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            CPF responsável financeiro
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
              .Cpf_responsavel
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Data Nascimento Aluno
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosPessoa.datanascimento_abertura
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Telefone
            <div class="d-flex">
              <input type="text" class="form-control w-75" v-model="fastTesourariaRenegociacao.dadosPessoa.telefone"
                readonly />
              <div>
                <a target="_blank" :href="retornaLinkWhats(
                  `${fastTesourariaRenegociacao.dadosPessoa.ddi}${fastTesourariaRenegociacao.dadosPessoa.telefone}`
                )
                  " class="btn btn-sm btn-success pb-0 pt-0 ml-2">
                  <small><b-icon icon="share" aria-hidden="true"></b-icon>
                    WhatsApp</small>
                </a>
              </div>
            </div>
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Matrícula
            <input type="text" class="form-control" v-model="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
              .Id_matricula
              " placeholder="Matrícula não encontrada" readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Total pendente
            <input type="text" class="form-control text-danger" v-model="fastTesourariaRenegociacao.dadosRenegociacao
              .valor_total_devido_str
              " readonly />
          </label>
          <label class="col-sm-12 col-md-4 col-lg-4">
            Invoice
            <div class="d-flex">
              <input type="text" class="form-control w-75" v-model="fastTesourariaRenegociacao.dadosRenegociacao
                .invoice_original.Id_invoice
                " readonly />
              <div>
                <button @click="
                  $store.state.fastControlaComponentes.alteraNavegacaoInvoices =
                  fastTesourariaRenegociacao.dadosRenegociacao.invoice_original.Id_invoice
                  " class="btn btn-sm btn-primary pb-0 pt-0 ml-2">
                  <small>Ir para invoice</small>
                </button>
              </div>
            </div>
          </label>
        </div>
        <hr />
        <div v-if="fastTesourariaPlataforma.steps === 1">
          <div class="m-3">
            <h4>Dados do invoice original:</h4>
            <div v-if="
              fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
            " class="row col-12">
              <h6 class="col-6">
                Total invoice:
                {{
                  fastTesourariaRenegociacao.dadosRenegociacao.invoice_original.Total.toLocaleString(
                    "pt-br",
                    { style: "currency", currency: "BRL" }
                  )
                }}
              </h6>
              <h6 class="col-6">
                Data do registro:
                {{
                  new Date(
                    fastTesourariaRenegociacao.dadosRenegociacao.invoice_original.Data_registro
                  ).toLocaleDateString()
                }}
              </h6>
            </div>
          </div>
          <hr />
          <div class="row d-flex justify-content-around col-sm-12 col-md-12 col-lg-12"
            v-if="fastTesourariaRenegociacao.dadosRenegociacao.invoice_original">
            <label class="col-sm-12 col-md-3 col-lg-3 text-nowrap">
              Gateway de pagamento
              <select name="gatewayPagamento" id="gatewayPagamento" @change="validaOpcoesFormaPgto()"
                v-model="fastTesourariaRenegociacao.dadosRenegociacao.gateway.id_pagamento_gateway"
                class="form-control">
                <option v-for="gateway in fastTesourariaPlataforma.gatewaysPagamento"
                  :key="gateway.id_pagamento_gateway" :value="gateway.id_pagamento_gateway">
                  {{ gateway.nome_gateway }}
                </option>
              </select>
            </label>
            <label class="col-sm-12 col-md-3 col-lg-3 text-nowrap">
              Data da primeira parcela
              <input type="date" class="form-control" v-model="fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada
                " />
            </label>
            <label class="col-sm-12 col-md-3 col-lg-3 text-nowrap">
              Forma de pagamento
              <select name="formaPagamento" id="formaPagamento" class="form-control" @change="removeTabelaSimulacao"
                v-model="fastTesourariaRenegociacao.parcelaRenegociacao
                  .formaPgtoSelecionada
                  ">
                <option value="">Selecione</option>
                <option v-for="forma in fastTesourariaPlataforma.formasPagamentoRecursos.lista"
                  :key="forma.forma_pagamento_sigla" :value="forma.forma_pagamento_sigla">
                  {{ forma.forma_pagamento }}
                </option>
              </select>
            </label>

            <label class="col-sm-12 col-md-3 col-lg-3 text-nowrap">
              Desconto sobre juros (%)
              <input type="number" class="form-control" @change="removeTabelaSimulacao"
                v-model="fastTesourariaRenegociacao.descontoTotal" />
            </label>
          </div>
          <div class="text-center">
            <button class="btn btn-primary" @click="validaGerarCalculos">
              Gerar calculos
            </button>
          </div>
          <hr />
          <div v-if="!fastTesourariaPlataforma.mostraTabelaSimulacao" class="w-100 text-center my-3">
            Selecione os dados de renegociação para visualizar a tabela
          </div>
          <div v-else>
            <h4>Escolha o número de parcelas negociado:</h4>
            <table class="table table-striped border border-dark">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">X</th>
                  <th class="text-center">Parcelas</th>
                  <th class="text-center" v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaCartao">
                    Valor juros + multa Cartão</th>
                  <th class="text-center" v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaBoleto">
                    Valor juros + multa Boleto</th>
                  <th class="text-center" v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaCartao">
                    Cartão parcela</th>
                  <th class="text-center" v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaBoleto">
                    Boleto parcela</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="e in !fastTesourariaPlataforma.formasPagamentoRecursos.permiteParcelamento
                  ? fastTesourariaRenegociacao.dadosRenegociacao.resultado_calculo.slice(
                    0,
                    1
                  )
                  : fastTesourariaRenegociacao.dadosRenegociacao
                    .resultado_calculo" :key="e.parcela">
                  <td class="d-flex justify-content-center px-2">
                    <input class="form-check-input m-0" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                      :value="e" @click="selecionaParcela(e)" />
                  </td>
                  <td class="text-nowrap text-center">
                    {{ e.parcela }}
                  </td>
                  <td class="text-nowrap text-center"
                    v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaCartao">
                    <strong>{{ e.valor_juros_multa_cartao_str }}</strong>
                  </td>
                  <td class="text-nowrap text-center"
                    v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaBoleto">
                    <strong>{{ e.valor_juros_multa_boleto_str }}</strong>
                  </td>
                  <td class="text-nowrap text-center"
                    v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaCartao">
                    {{ e.cartao_parcela_str }}
                  </td>
                  <td class="text-nowrap text-center"
                    v-if="fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaBoleto">
                    {{ e.boleto_parcela_str }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center">
              <button v-if="
                !Object.keys(
                  fastTesourariaRenegociacao.parcelaRenegociacao
                    .parcelaSelecionada
                ).length" class="btn btn-success" disabled>
                Avançar para simulação
              </button>
              <button v-else class="btn btn-success" @click="simulaRenegociacao">
                Avançar para simulação
              </button>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div v-if="fastTesourariaPlataforma.steps === 2" class="pb-3 px-3">
        <div class="m-4">
          <h4 class="mb-3">Revisão de renegociação:</h4>
          <p>
            Valor total:
            <strong>
              {{
                fastTesourariaRenegociacao.simulacaoRealizada.valor_total_str
              }}
            </strong>
          </p>
          <p>
            Status:
            <strong v-if="fastTesourariaRenegociacao.simulacaoRealizada.cancelado"
              class="text-danger">Cancelado</strong>
            <strong v-else-if="
              fastTesourariaRenegociacao.simulacaoRealizada.estornado
            " class="text-success">Estornado</strong>
            <strong v-else-if="fastTesourariaRenegociacao.simulacaoRealizada.pago" class="text-success">Pago</strong>
            <strong v-else-if="fastTesourariaRenegociacao.simulacaoRealizada.pendente">Pendente</strong>
            <strong v-else-if="fastTesourariaRenegociacao.simulacaoRealizada.vencido"
              class="text-danger">Vencido</strong>
            <strong v-else>Aguardando</strong>
          </p>
        </div>
        <table class="table table-striped border border-dark">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Parcela</th>
              <th class="text-center">Valor</th>
              <th class="text-center">Data Vencimento</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(e, index) in fastTesourariaRenegociacao.simulacaoRealizada
              .parcelas" :key="e.parcela">
              <td class="text-nowrap text-center">
                {{ index + 1 }}
              </td>
              <td class="text-nowrap text-center">
                {{ e.valor_parcela_str }}
              </td>
              <td class="text-nowrap text-center">
                {{ e.data_vencimento }}
              </td>
              <td class="text-nowrap text-center">
                <strong>Aguardando confirmação</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-around">
          <button class="btn btn-primary" @click="fastTesourariaPlataforma.steps = 1">
            Voltar para o passo anterior
          </button>
          <button class="btn btn-success" @click="
            confirmaRenegociacao(
              fastTesourariaRenegociacao.parcelaRenegociacao
                .formaPgtoSelecionada
            )
            ">
            Confirmar geração de cobrança
          </button>
        </div>
      </div>
      <div v-if="fastTesourariaPlataforma.steps === 3" class="pb-3 px-3">
        <div class="m-4">
          <h4 class="mb-3">Cobrança gerada:</h4>
          <p>
            Valor total:
            <strong>
              {{
                fastTesourariaRenegociacao.simulacaoRealizada.valor_total_str
              }}
            </strong>
          </p>
          <p>
            Status:
            <strong v-if="fastTesourariaRenegociacao.simulacaoRealizada.cancelado"
              class="text-danger">Cancelado</strong>
            <strong v-else-if="
              fastTesourariaRenegociacao.simulacaoRealizada.estornado
            " class="text-success">Estornado</strong>
            <strong v-else-if="fastTesourariaRenegociacao.simulacaoRealizada.pago" class="text-success">Pago</strong>
            <strong v-else-if="fastTesourariaRenegociacao.simulacaoRealizada.vencido"
              class="text-danger">Vencido</strong>
            <strong v-else>Pendente</strong>
          </p>
        </div>
        <table class="table table-striped border border-dark">
          <thead class="thead-dark">
            <tr>
              <th class="text-center">Parcela</th>
              <th class="text-center">Data Vencimento</th>
              <th class="text-center">Valor</th>
              <th class="text-center">Status</th>
              <th class="text-center">Link de cobrança</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(e, index) in fastTesourariaRenegociacao.simulacaoRealizada
              .parcelas" :key="e.parcela">
              <td class="text-nowrap text-center">
                {{ index + 1 }}
              </td>
              <td class="text-nowrap text-center">
                {{ e.valor_parcela_str }}
              </td>
              <td class="text-nowrap text-center">
                {{ e.data_vencimento }}
              </td>
              <td class="text-nowrap text-center">
                <strong v-if="e.cancelado" class="text-danger">Cancelado</strong>
                <strong v-else-if="e.estornado" class="text-success">Estornado</strong>
                <strong v-else-if="e.pago" class="text-success">Pago</strong>
                <strong v-else-if="e.vencido" class="text-danger">Vencido</strong>
                <strong v-else>Pendente</strong>
              </td>
              <td class="text-nowrap text-center">
                <a :href="e.url_cobranca_gateway" target="_blank" class="btn btn-primary">
                  <small> Acessar parcela {{ index + 1 }} </small>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-around">
          <button class="btn btn-primary" @click="fastTesourariaPlataforma.steps = 2">
            Voltar para o passo anterior
          </button>
          <button class="btn btn-success" @click="
          ($store.state.fastControlaComponentes.alteraNavegacaoRenegociada =
            fastTesourariaPlataforma.alteraNavegacao),
            ($store.state.fastCarregando = true)
            ">
            Avançar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import methods from "@/methods";

export default {
  name: "RenegociacaoDividas",
  props: {
    id_plataforma: {
      type: Number,
      required: true,
    },
    id_invoice: {
      type: Number,
      required: true,
    },
    id_invoice_pai: {
      type: Number,
      required: false,
    },
    dados_invoice: {
      type: Object,
      required: true,
    },
  },
  mixins: [methods],
  data: function () {
    return {
      modalWidthSm: this.isMobile() ? "80%" : "30%",
      modalWidthMd: this.isMobile() ? "90%" : "50%",
      modalWidthLg: this.isMobile() ? "100%" : "90%",
      fastTesourariaPlataforma: {
        loading: true,
        steps: 1,
        gatewaysPagamento: [],
        formasPagamento: [],
        formasPagamentoRecursos: {
          lista: [],
          permiteParcelamento: false,
          exibeColunaCartao: false,
          exibeColunaBoleto: false,
        },
        mostraTabelaSimulacao: false,
        alteraNavegacao: "",
        mostraRenegociacao: false,
      },
      fastTesourariaRenegociacao: {
        dadosRenegociacao: {},
        dadosPessoa: {},
        parcelaRenegociacao: {
          parcelaSelecionada: {},
          dataSelecionada: "",
          formaPgtoSelecionada: "",
          parcelasRenegociadas: [],
        },
        descontoTotal: 0,
        simulacaoRealizada: [],
        listaContasReceber: [],
        statusDocumentos: {
          pagamento: {
            pathComprovante: "",
            statusComprovante: false,
          },
          contrato: {
            gerado: false,
            assinado: false,
          },
        },
      },
    };
  },
  mounted() {
    this.getTaxasAcordoGatewayListaCalculo();
    this.getGatewaysPagamento();
    this.getFormasPagamento();
  },
  methods: {
    async getTaxasAcordoGatewayListaCalculo() {
      this.fastTesourariaPlataforma.loading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_tesouraria_taxas_acordo_gateway/lista_calculo",
          `id_plataforma=${this.id_plataforma}&id_invoice=${this.id_invoice}${Object.keys(this.fastTesourariaRenegociacao.dadosRenegociacao)
            .length &&
            this.fastTesourariaRenegociacao.dadosRenegociacao.gateway
              .id_pagamento_gateway
            ? "&id_pagamento_gateway=" +
            this.fastTesourariaRenegociacao.dadosRenegociacao.gateway
              .id_pagamento_gateway
            : ""
          }${Object.keys(this.fastTesourariaRenegociacao.dadosRenegociacao)
            .length &&
            this.fastTesourariaRenegociacao.descontoTotal
            ? "&desconto_juros=" +
            this.fastTesourariaRenegociacao.descontoTotal
            : ""
          }`
        ).then((res) => {
          if (res.success === false) {
            if (
              res.error ==
              "O invoice informado não possui nenhuma parcela vencida." &&
              this.fastTesourariaRenegociacao.parcelaRenegociacao
                .parcelasRenegociadas.length
            ) {
              this.processaRenegociacao(null);
            } else {
              this.apiCallErrorHandler(res);
              this.fastTesourariaPlataforma.mostraTabelaSimulacao = false;
              this.fastTesourariaRenegociacao.parcelaRenegociacao.formaPgtoSelecionada = ""
              this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada = ""
              if (
                res.error ==
                "O invoice informado não possui nenhuma parcela vencida."
              ) {
                this.$store.state.fastControlaComponentes.alteraNavegacaoRetornaRelatorio = true;
              }
            }
          } else {
            this.processaRenegociacao(res);
          }
        });
        this.fastTesourariaPlataforma.loading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastTesourariaPlataforma.loading = false;
      }
    },
    async processaRenegociacao(res) {
      if (res) {
        this.fastTesourariaRenegociacao.dadosRenegociacao = res;
      }
      let pessoa =
        Object.keys(this.fastTesourariaRenegociacao.dadosRenegociacao).length &&
          this.fastTesourariaRenegociacao.dadosRenegociacao.valor_total_devido
          ? this.fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
            .Id_pessoa_aluno
          : this.fastTesourariaRenegociacao.parcelaRenegociacao
            .parcelasRenegociadas[0].id_pessoa_aluno;

      await this.getDadosPessoa(pessoa);

      this.exibeToasty("Dados carregados", "success");
    },
    async getGatewaysPagamento() {
      this.fastTesourariaPlataforma.loading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_pagamento_gateway/lista_disponiveis",
          `id_plataforma=${this.id_plataforma}`
        ).then((res) => {
          if (res.success === false) {
            this.apiCallErrorHandler(res);
          } else {
            this.fastTesourariaPlataforma.gatewaysPagamento = res;
            this.fastTesourariaRenegociacao.dadosRenegociacao.gateway = res[0]
            this.filtraFormaPagamento()
          }
        });
        this.fastTesourariaPlataforma.loading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastTesourariaPlataforma.loading = false;
      }
    },
    async getFormasPagamento() {
      this.fastTesourariaPlataforma.loading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_tesouraria_tipo_pagamento/lista",
          `id_plataforma=${this.id_plataforma}`
        ).then((res) => {
          if (res.success === false) {
            this.apiCallErrorHandler(res);
          } else {
            this.fastTesourariaPlataforma.formasPagamento = res;
          }
        });
        this.fastTesourariaPlataforma.loading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastTesourariaPlataforma.loading = false;
      }
    },
    async getDadosPessoa(id_pessoa) {
      this.fastTesourariaPlataforma.loading = true;
      try {
        await this.promiseGetFastApi(
          "api/fast_plataforma_usuario/busca_pessoa_secretaria",
          `id_plataforma=${this.id_plataforma}&id_pessoa=${id_pessoa}`
        ).then((resp) => {
          const res = JSON.parse(resp);
          if (res.success === false || res.error) {
            this.apiCallErrorHandler(res);
          } else {
            this.fastTesourariaRenegociacao.dadosPessoa = res;
            this.fastTesourariaRenegociacao.dadosPessoa.datanascimento_abertura =
              new Date(
                this.fastTesourariaRenegociacao.dadosPessoa.datanascimento_abertura
              ).toLocaleDateString("pt-BR");
          }
        });
        this.fastTesourariaPlataforma.loading = false;
      } catch (error) {
        console.error(error);
        this.exibeToasty("Ocorreu um erro", "error");
        this.fastTesourariaPlataforma.loading = false;
      }
    },
    retornaLinkWhats(telefone) {
      let link = "";
      let tel = telefone;
      tel = telefone
        .replaceAll("-", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "");
      link = `https://api.whatsapp.com/send?phone=${tel}`;
      return link;
    },
    selecionaParcela(e) {
      this.fastTesourariaRenegociacao.parcelaRenegociacao.parcelaSelecionada =
        e;
    },
    retornaIdTipoPagamento() {
      let id_tipo_pagamento = this.fastTesourariaPlataforma.formasPagamento.filter(
        (e) =>
          e.forma_pagamento ==
          this.fastTesourariaRenegociacao.parcelaRenegociacao.formaPgtoSelecionada
      );
      return id_tipo_pagamento[0].id_tipo_pagamento;
    },
    async simulaRenegociacao() {
      this.$store.state.fastCarregando = true;
      let errors = [];
      if (!this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada)
        errors.push("Deve ser selecionada a data da primeira ou única parcela");

      let obj = {
        id_plataforma: this.id_plataforma,
        id_invoice: this.id_invoice,
        id_pagamento_gateway:
          Object.keys(this.fastTesourariaRenegociacao.dadosRenegociacao)
            .length &&
          this.fastTesourariaRenegociacao.dadosRenegociacao.gateway
            .id_pagamento_gateway,
        id_plano_pagamento: this.fastTesourariaRenegociacao.parcelaRenegociacao.parcelaSelecionada.id_plano_pagamento,
        id_tipo_pagamento: this.retornaIdTipoPagamento(),
        id_pessoa_responsavel:
          this.fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
            .Id_pessoa_responsavel,
        data_vencimento_primeira_parcela:
          this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada +
          "T23:59:59",
        // comissao: [
        //   {
        //     id_comissao_schema: 0,
        //     id_determinacao: 0,
        //     id_pessoa_fastead: 0,
        //     id_pessoa_gateway: "",
        //     comissao_porcentagem: 0,
        //     comissao_valor: 0,
        //   },
        // ],
        desconto_juros:
          this.fastTesourariaRenegociacao.descontoTotal,
      };

      if (!obj.id_pagamento_gateway)
        errors.push("Deve ser selecionado um gateway de pagamento");
      if (!obj.id_plano_pagamento)
        errors.push("Deve ser selecionada uma parcela para pagamento");

      if (errors.length) {
        errors.forEach((element) => {
          this.exibeToasty(element, "error");
        });
      } else {
        this.fastTesourariaPlataforma.loading = true;
        try {
          await this.promisePostFastApi(
            obj,
            "api/fast_tesouraria_taxas_acordo_gateway/simula_renegociacao"
          ).then((res) => {
            if (res.success == false) {
              this.apiCallErrorHandler(res);
            } else {
              this.fastTesourariaPlataforma.steps = 2;
              this.fastTesourariaRenegociacao.simulacaoRealizada = res;
              this.$store.state.fastCarregando = false;
            }
          });
          this.$store.state.fastCarregando = false;
          this.fastTesourariaPlataforma.loading = false;
        } catch (error) {
          console.error(error);
          this.exibeToasty("Ocorreu um erro", "error");
          this.fastTesourariaPlataforma.loading = false;
          this.$store.state.fastCarregando = false;
        }
      }
    },
    async confirmaRenegociacao() {
      this.$store.state.fastCarregando = true;
      let errors = [];
      if (!this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada)
        errors.push("Deve ser selecionada a data da primeira ou única parcela");

      let obj = {
        id_plataforma: this.id_plataforma,
        id_invoice: this.id_invoice,
        id_pagamento_gateway:
          Object.keys(this.fastTesourariaRenegociacao.dadosRenegociacao)
            .length &&
          this.fastTesourariaRenegociacao.dadosRenegociacao.gateway
            .id_pagamento_gateway,
        id_plano_pagamento: this.fastTesourariaRenegociacao.parcelaRenegociacao.parcelaSelecionada.id_plano_pagamento,
        id_tipo_pagamento: this.retornaIdTipoPagamento(),
        id_pessoa_responsavel:
          this.fastTesourariaRenegociacao.dadosRenegociacao.invoice_original
            .Id_pessoa_responsavel,
        data_vencimento_primeira_parcela:
          this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada +
          "T23:59:59",
        desconto_juros:
          this.fastTesourariaRenegociacao.descontoTotal,
      };

      if (!obj.id_pagamento_gateway)
        errors.push("Deve ser selecionado um gateway de pagamento");
      if (!obj.id_plano_pagamento)
        errors.push("Deve ser selecionada uma parcela para pagamento");

      if (errors.length) {
        errors.forEach((element) => {
          this.exibeToasty(element, "error");
        });
      } else {
        this.fastTesourariaPlataforma.loading = true;
        try {
          await this.promisePostFastApi(
            obj,
            "api/fast_tesouraria_taxas_acordo_gateway/confirma_renegociacao"
          ).then((res) => {
            if (res.success === false) {
              this.apiCallErrorHandler(res);
              if (res.error === "A task was canceled.")
                this.exibeToasty(
                  "Por favor, tente novamente mais tarde",
                  "info"
                );
              this.$store.state.fastCarregando = false;
              this.fastTesourariaPlataforma.loading = false;
            } else {
              this.fastTesourariaRenegociacao.simulacaoRealizada = res;
              this.fastTesourariaPlataforma.alteraNavegacao =
                this.fastTesourariaRenegociacao.simulacaoRealizada.id_invoice;
              this.$store.state.fastCarregando = false;
              this.fastTesourariaPlataforma.loading = false;
              this.fastTesourariaPlataforma.steps = 3;
            }
          });
        } catch (error) {
          console.error(error);
          this.exibeToasty("Ocorreu um erro", "error");
          this.$store.state.fastCarregando = false;
          this.fastTesourariaPlataforma.loading = true;
        }
      }
    },
    async validaGerarCalculos() {
      if (!this.fastTesourariaRenegociacao.parcelaRenegociacao
        .formaPgtoSelecionada || !this.fastTesourariaRenegociacao.parcelaRenegociacao.dataSelecionada) { this.exibeToasty("É necessário selecionar a forma de pagamento e a data da primeira parcela", "error") } else if (!this.dados_invoice.renegociacao_liberada) { this.exibeToasty("Ainda não é possível realizar essa ação", "error") } else {
          this.fastTesourariaRenegociacao.descontoTotal = Number(this.fastTesourariaRenegociacao.descontoTotal)
          if (this.fastTesourariaRenegociacao.descontoTotal < 0 || !(typeof this.fastTesourariaRenegociacao.descontoTotal === 'number')){
            this.fastTesourariaRenegociacao.descontoTotal = 0
          }
          console.log(this.fastTesourariaRenegociacao.descontoTotal);

          await this.getTaxasAcordoGatewayListaCalculo();
          this.validaCamposTabelaSimulacao()
          this.fastTesourariaPlataforma.mostraTabelaSimulacao = true;
        }
    },
    removeTabelaSimulacao() {
      this.fastTesourariaPlataforma.mostraTabelaSimulacao = false;
      this.fastTesourariaRenegociacao.parcelaRenegociacao.parcelaSelecionada = {};
    },
    filtraFormaPagamento() {
      this.fastTesourariaPlataforma.formasPagamentoRecursos.lista = this.fastTesourariaPlataforma.gatewaysPagamento
        .find(f => f.id_pagamento_gateway == this.fastTesourariaRenegociacao.dadosRenegociacao.gateway.id_pagamento_gateway).recursos.filter(f => f.suportado)
    },
    validaOpcoesFormaPgto() {
      this.fastTesourariaPlataforma.mostraTabelaSimulacao = false;
      this.fastTesourariaRenegociacao.parcelaRenegociacao
        .formaPgtoSelecionada = ""
      this.filtraFormaPagamento()
    },
    validaCamposTabelaSimulacao() {
      this.fastTesourariaPlataforma.formasPagamentoRecursos.permiteParcelamento = this.fastTesourariaPlataforma.formasPagamentoRecursos.lista.find(f => f.forma_pagamento_sigla == this.fastTesourariaRenegociacao.parcelaRenegociacao.formaPgtoSelecionada).recursos_bool.parcelamento
      let idFormaPgto = this.fastTesourariaRenegociacao.parcelaRenegociacao.formaPgtoSelecionada
      if (idFormaPgto === "P" || idFormaPgto === "B" || idFormaPgto === "N" || idFormaPgto === "P" || idFormaPgto === "L" || idFormaPgto === "E") this.fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaBoleto = true
      if (idFormaPgto === "C" || idFormaPgto === "D" || idFormaPgto === "L" || idFormaPgto === "E") this.fastTesourariaPlataforma.formasPagamentoRecursos.exibeColunaCartao = true
    },
  },
};
</script>

<style>
.steps-guide-active,
.steps-guide {
  box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.2);
}

.steps-guide-active,
.steps-guide {
  border: none;
  padding: 1em 3em;
  border-radius: 16px;
  transition: 0.5s;
  color: #fff;
  font-weight: 600;
  min-height: 7em;
  align-content: center;
}

.steps-guide {
  background-color: #e66e10;
}

.steps-guide-active {
  background-color: #015b97;
}

.steps-guide-disabled {
  background-color: #aaaaaa;
}

.steps-header button:disabled {
  background-color: #dadada;
}

.steps-icon {
  color: #e66e10;
  font-size: 3em;
}

.form-check-input {
  position: relative;
}

.blink_me {
  animation: destacaBotao 500ms alternate infinite ease-in;
}

.vm--modal {
  overflow: scroll;
  min-height: 90svh;
}

@keyframes destacaBotao {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}
</style>
